import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import Router from 'common/Router/Router';

const { CLIENT_PROFILE } = COMPONENT_TYPES;

const ClientProfileSubRouter = ({
  getAvailableRoutes,
  parentRoute,
  tabs = [],
  withRedirect = true,
}) => {
  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);

  const availableRoutes = useMemo(() => getAvailableRoutes(clientProfilePath), [clientProfilePath]);

  const routerRoutes = useMemo(
    () => tabs.map(({ type }) => availableRoutes[type]).filter(i => i),
    [tabs, availableRoutes],
  );

  const urlToRedirect = useMemo(() => {
    if (!withRedirect) return null;
    if (routerRoutes.length === 0) return '/';
    return routerRoutes[0].path;
  }, [routerRoutes]);

  return (
    <Router
      redirectFrom={`${clientProfilePath}/${parentRoute}`}
      redirectTo={urlToRedirect}
      routes={routerRoutes}
    />
  );
};

ClientProfileSubRouter.propTypes = {
  getAvailableRoutes: PropTypes.func.isRequired,
  parentRoute: PropTypes.string.isRequired,
  tabs: PropTypes.array,
  withRedirect: PropTypes.bool,
};

export default ClientProfileSubRouter;
